export enum Mount {
  CANON_EF = "101010",
  CANON_EF_S = "101011",
  CANON_RF = "101020",
  CANON_RF_S = "101021",
  CANON_M = "101030",
  NIKON_F = "101110",
  NIKON_F_DX = "101111",
  NIKON_Z = "101120",
  NIKON_Z_DX = "101121",
  SONY_E = "101210",
  SONY_E_APS_C = "101211",
  SONY_A = "101220",
  SONY_A_APS_C = "101221",
  PENTAX_K = "101310",
  PENTAX_K_APS_C = "101311",
  FUJIFILM_X = "101410",
  FUJIFILM_G = "101420",
  L_MOUNT = "101510",
  L_MOUNT_APS_C = "101511",
  MICRO_FOUR_THIRDS = "101610",
}